import React from 'react';
import { useTranslation } from 'react-i18next';
import FilloutButton from '@/components/FilloutButton';

const JotformCTASection = () => {
  const { t } = useTranslation('jotform');

  return (
    <section className="py-20 bg-gradient-to-br from-primary/10 to-accent/10">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <h2 className="text-3xl md:text-4xl font-bold">{t('cta.title')}</h2>
          <h3 className="text-xl text-primary font-semibold">{t('cta.subtitle')}</h3>
          <p className="text-lg text-muted-foreground">{t('cta.description')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <FilloutButton className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-4 text-lg font-semibold">
              {t('cta.primaryButton')}
            </FilloutButton>
            <FilloutButton variant="outline" className="px-8 py-4 text-lg font-semibold border-2">
              {t('cta.secondaryButton')}
            </FilloutButton>
          </div>
          <p className="text-sm text-muted-foreground">{t('cta.guaranteeText')}</p>
        </div>
      </div>
    </section>
  );
};

export default JotformCTASection;